import Cancelation from "./Cancelation";
import Attachments from "./Attachments";
import Document from "./Document";
import ConnectedContracts from "./ConnectedContracts";
import Confirm from "./Confirm";
export default {
  CANCELATION: Cancelation,
  ATTACHMENTS: Attachments,
  DOCUMENT: Document,
  CONNECTED_CONTRACTS: ConnectedContracts,
  CONFIRM: Confirm,
};
